/*
@TODO: Switch to this across all the indices
Currently used:
- parts/alpine/documentLibraryAlgolia.js
 */

const shared = {
  appId: window.agI,
  apiKey: window.agSk,
}

const siteConfig = {
  ...shared,
  index: window.agSi,
}

const catalogConfig = {
  ...shared,
  index: window.agSc,
}

const documentLibraryConfig = {
  ...shared,
  index: window.agDl,
}

const webinarsConfig = {
  ...shared,
  index: window.agWi,
}

export {
  documentLibraryConfig, catalogConfig, siteConfig, webinarsConfig,
}
